import React from 'react';
import PropTypes from 'prop-types';

const AddPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M19 13h8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-8v8a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-8H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h8V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v8z"
    />
  );
};

AddPath.propTypes = {
  fill: PropTypes.string,
};

export default AddPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/add.jsx